export * from './access-denied-page.component';
